/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Type of form.
 */
export enum FormType {
    OTHER = 'Other',
    WORKFLOW_DEFINITION_MAIN_FORM = 'WorkflowDefinitionMainForm',
    WORKFLOW_STEP = 'WorkflowStep',
    COMPLIANCE_ITEM_DEFINITION = 'ComplianceItemDefinition',
    ENTITY_DEFINITION = 'EntityDefinition',
    EMAIL_TEMPLATE = 'EmailTemplate',
    EMAIL_STYLE_TEMPLATE = 'EmailStyleTemplate',
    MAIN_APPLICATION = 'MainApplication',
    MEDICAL_FORMS = 'MedicalForms',
    NEEDS_ASSESSMENT = 'NeedsAssessment',
    APPLICATION_UPDATE_REQUEST = 'ApplicationUpdateRequest',
    HMBINFORMATION_UPDATE_REQUEST = 'HMBInformationUpdateRequest',
    APPLICATION_NOTE = 'ApplicationNote',
    OFFER = 'Offer',
    NO_OFFER = 'NoOffer',
    INTAKE = 'Intake',
    IMPORTED_INFORMATION = 'ImportedInformation',
    CANCEL_APPLICATION = 'CancelApplication',
    MOVE_BACK_TO_REVIEW = 'MoveBackToReview',
    MOVE_BACK_TO_WAITLIST = 'MoveBackToWaitlist',
    CONFIGURED_FORM = 'ConfiguredForm',
}
